(() => {
  // src/scripts/main.js
  document.addEventListener("switch:alpine:started", () => {
    const Alpine = window.Alpine;
    Alpine.store("theme", {
      init() {
        console.log("Custom theme store initialized");
      },
      // Add your custom store properties and methods here
      darkMode: false,
      toggleDarkMode() {
        this.darkMode = !this.darkMode;
      }
    });
    Alpine.data("customComponent", () => ({
      init() {
        console.log("Custom component initialized");
      },
      // Add your component data and methods here
      message: "Hello from custom Alpine component!",
      updateMessage(newMessage) {
        this.message = newMessage;
      }
    }));
    registerCustomComponents(Alpine);
    console.log("Custom theme extensions loaded");
  });
  function registerCustomComponents(Alpine) {
    Alpine.data("productGallery", () => ({
      currentImage: 0,
      images: [],
      init() {
        this.images = Array.from(this.$el.querySelectorAll("img")).map((img) => ({
          src: img.src,
          alt: img.alt
        }));
      },
      nextImage() {
        this.currentImage = (this.currentImage + 1) % this.images.length;
      },
      prevImage() {
        this.currentImage = this.currentImage === 0 ? this.images.length - 1 : this.currentImage - 1;
      },
      setImage(index) {
        this.currentImage = index;
      }
    }));
    Alpine.data("enhancedCartDrawer", () => ({
      isLoading: false,
      async addToCart(variantId, quantity = 1) {
        this.isLoading = true;
        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: variantId,
              quantity
            })
          });
          if (response.ok) {
            document.dispatchEvent(new CustomEvent("cart:updated"));
          } else {
            console.error("Failed to add item to cart");
          }
        } catch (error) {
          console.error("Error adding to cart:", error);
        } finally {
          this.isLoading = false;
        }
      }
    }));
    Alpine.data("newsletterSignup", () => ({
      email: "",
      isLoading: false,
      message: "",
      isSuccess: false,
      async subscribe() {
        if (!this.email || !this.isValidEmail(this.email)) {
          this.message = "Please enter a valid email address";
          this.isSuccess = false;
          return;
        }
        this.isLoading = true;
        this.message = "";
        try {
          const response = await fetch("/contact", {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams({
              "form_type": "customer",
              "utf8": "\u2713",
              "contact[tags]": "newsletter",
              "contact[email]": this.email
            })
          });
          if (response.ok) {
            this.message = "Thank you for subscribing!";
            this.isSuccess = true;
            this.email = "";
          } else {
            this.message = "Sorry, there was an error. Please try again.";
            this.isSuccess = false;
          }
        } catch (error) {
          this.message = "Sorry, there was an error. Please try again.";
          this.isSuccess = false;
        } finally {
          this.isLoading = false;
        }
      },
      isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      }
    }));
  }
  function debounce(fn, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        fn(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  function throttle(fn, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        fn.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
  var ThemeUtils = {
    // Add utility functions specific to your theme
    formatPrice(price) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(price / 100);
    },
    // Image lazy loading utility
    setupLazyLoading() {
      const images = document.querySelectorAll("img[data-src]");
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.classList.remove("lazy");
            imageObserver.unobserve(img);
          }
        });
      });
      images.forEach((img) => imageObserver.observe(img));
    }
  };
  document.addEventListener("DOMContentLoaded", () => {
    ThemeUtils.setupLazyLoading();
    console.log("Custom theme scripts loaded");
  });
})();
